'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');
var _uniq = require('lodash/uniq');var _uniq2 = _interopRequireDefault(_uniq);
var _get2 = require('lodash/get');var _get3 = _interopRequireDefault(_get2);
var _noop = require('lodash/noop');var _noop2 = _interopRequireDefault(_noop);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);

var _PublishAutocompleteLocationInput = require('../../../containers/PublishAutocompleteLocationInput/PublishAutocompleteLocationInput');var _PublishAutocompleteLocationInput2 = _interopRequireDefault(_PublishAutocompleteLocationInput);
var _components = require('../../../components');
var _PublishFormCountriesSelect = require('./PublishFormCountriesSelect');var _PublishFormCountriesSelect2 = _interopRequireDefault(_PublishFormCountriesSelect);

var _constants = require('../../../constants');
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _reduxFormNormalizers = require('../../../helpers/reduxFormNormalizers');
var _googleService = require('../../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);
var _slugify = require('../../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _TranslationService = require('../../../services/TranslationService');var _TranslationService2 = _interopRequireDefault(_TranslationService);
var _countriesMin = require('../../../services/MapboxService/countries.min.json');var _countriesMin2 = _interopRequireDefault(_countriesMin);

var _PublishFormLocationInput = require('./PublishFormLocationInput.scss');var styles = _interopRequireWildcard(_PublishFormLocationInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var placeholderMap = { country_name: 'country', city_name: 'city',
  street_name: 'street' };var


PublishFormLocationInput = function (_Component) {_inherits(PublishFormLocationInput, _Component);
  function PublishFormLocationInput(props) {_classCallCheck(this, PublishFormLocationInput);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    _this.trackSearch = (0, _debounce2.default)(_this.trackSearch.bind(_this), 1000);
    _this.debouncedGetAutocompleteSuggestions = (0, _debounce2.default)(_this.getAutocompleteSuggestions, 500, { leading: false });
    var isoCode = _this.getCountryCode(_this.props.address.country_name) ||
    _googleService2.default.OPTIONS.componentRestrictions.country;

    _this.state = {
      suggestions: [],
      fieldInFocus: '',
      errors: [],
      showTooltip: false,
      isoCode: isoCode };return _this;

  }PublishFormLocationInput.prototype.

  componentDidMount = function componentDidMount() {
    this.country = this.country || document.getElementsByName(this.props.name + '.country_name')[0];
    this.city = this.city || document.getElementsByName(this.props.name + '.city_name')[0];
    this.street = this.street || document.getElementsByName(this.props.name + '.street_name')[0];

    if (!this.props.isForeign) {
      this.country && this.city.setAttribute('autocomplete', this.props.name + '.country_name');
      this.city && this.city.setAttribute('autocomplete', this.props.name + '.city_name');
      this.street && this.street.setAttribute('autocomplete', this.props.name + '.street_name');
    }

    this.props.getComponentInstance && this.props.getComponentInstance(this);
  };PublishFormLocationInput.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (!(0, _get3.default)(this.props, 'address.house_number') && (0, _get3.default)(newProps, 'address.house_number')) {
      this.setState({ errors: [] });
    }
  };PublishFormLocationInput.prototype.






































































































































  setError = function setError(error, callback) {
    this.setState(function (prevState) {return {
        errors: (0, _uniq2.default)([].concat(prevState.errors, [error])) };},
    callback || _noop2.default);
  };PublishFormLocationInput.prototype.

  clearErrors = function clearErrors(predicate, callback) {
    this.setState(function (prevState) {return {
        errors: prevState.errors.filter(predicate) };},
    callback || _noop2.default);
  };

























































































































































































































































  // Is called when user has selected a suggestion
  PublishFormLocationInput.prototype.





























































  render = function render() {var _cx,_cx2,_cx3,_cx4,_cx5,_cx6,_cx7,_cx8,_this2 = this;
    var houseNumber = (0, _get3.default)(this.props, 'address.house_number');
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: styles.fullAddressTitle }, this.props.translate('enterFullAddress')),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.locationInputWrapper, (_cx = {}, _cx[styles.error] = !!this.state.errors.length, _cx)) },
          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(
              styles.autocompleteWrapper, (_cx2 = {}, _cx2[
              styles.foreignFormWrapper] = this.props.isForeign, _cx2)) },


            this.props.isForeign &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(
                styles.inputWrapper,
                styles.country, (_cx3 = {}, _cx3[
                styles.invalidAddress] = this.isInvalidField('country_name'), _cx3)) },

              _react2.default.createElement(_PublishFormCountriesSelect2.default, {
                address: this.props.address,
                country_name: this.props.country_name,
                onChangeCountry: this.handleChangeCountry,
                isRtl: this.props.isRtl,
                locale: this.props.locale,
                translate: this.props.translate })),



            _react2.default.createElement('div', { className: (0, _classnames2.default)(
                styles.inputWrapper,
                styles.city, (_cx4 = {}, _cx4[
                styles.invalidAddress] = this.isInvalidField('city_name'), _cx4)) },

              _react2.default.createElement(_PublishAutocompleteLocationInput2.default,
              this.createInputParameters('city_name'))),


            _react2.default.createElement('div', { className: (0, _classnames2.default)(
                styles.inputWrapper,
                styles.street, (_cx5 = {}, _cx5[
                styles.invalidAddress] = this.isInvalidField('street_name'), _cx5)) },

              _react2.default.createElement(_PublishAutocompleteLocationInput2.default,
              this.createInputParameters('street_name'))),


            _react2.default.createElement('div', { className: (0, _classnames2.default)(
                styles.inputWrapper,
                styles.house, (_cx6 = {}, _cx6[
                styles.withTooltipImage] = this.props.withTooltipImage, _cx6), (_cx7 = {}, _cx7[
                styles.withTooltipImage] = this.props.withTooltipImage, _cx7), (_cx8 = {}, _cx8[
                styles.invalidAddress] = this.isInvalidField('house_number'), _cx8)) },

              _react2.default.createElement(_reduxForm.Field, {
                type: 'text',
                name: this.props.name + '.' + (this.props.isDefaultLanguage ?
                _constants.language.fallback :
                this.props.locale) + '.house_number',

                value: houseNumber,
                component: 'input',
                placeholder: this.props.translate('house'),
                normalize: !this.props.isForeign && _reduxFormNormalizers.maxThreeDigit,
                onFocus: this.handleFocus,
                onBlur: this.onHouseNumberBlur,
                onKeyDown: this.onHouseKeyDown,
                onChange: function onChange(e, value) {return _this2.onQueryStringChange('house_number', value);} }),


              this.renderInfoTooltipButton(),

              this.props.isRealtor && this.state.showTooltip &&
              _react2.default.createElement(_components.OMTooltip, {
                msg: '' + this.props.translate('houseNumberIsHidden'),
                className: 'mobileAuthenticationTooltip' }),


              houseNumber && !this.props.isFullAddress && !this.props.manualAddress &&
              _react2.default.createElement('button', { onClick: function onClick(evt) {return evt.preventDefault();}, className: styles.locationInputEnterButton }))),



          !!this.state.errors.length &&
          _react2.default.createElement('div', { className: styles.errorMessage },
            this.getErrorTooltip(this.state.errors)))));





  };return PublishFormLocationInput;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this3 = this;this.onHouseNumberBlur = function (event) {if (!event.target.value && !_this3.props.isForeign) {_this3.setError(_constants.publishFormErrorNames.houseIsRequired);_this3.props.clearAddressPart('house_number', '', true);return;}var house_number = event.target.value;if (!_this3.props.manualAddress) {_this3.tryToFindFullAddress(house_number);} else {_this3.props.setHomeNumberManually(house_number);}};this.onHouseKeyDown = function (event) {if (event.target.value) {_this3.clearErrors(function (error) {return !error.startsWith('HOUSE');});}if (event.keyCode === _constants.enterKey) {event.preventDefault();document.activeElement.blur();}};this.onQueryStringChange = function (type, query) {var address = _this3.props.address;if (type === 'city_name' && address.street_name) {_this3.clearErrors(function (error) {return !error.startsWith('HOUSE') && !error.startsWith('ADDRESS');});} else if (type === 'street_name' && address.house_number) {_this3.clearErrors(function (error) {return !error.startsWith('HOUSE') && !error.startsWith('ADDRESS');});}if (type === 'country_name' && address.country_name && address.country_name !== query) {_this3.props.clearAddressPart(type, query);}if (type === 'city_name' && address.city_name && address.city_name !== query) {_this3.props.clearAddressPart(type, query);}if (type === 'street_name' && address.street_name && address.street_name !== query) {_this3.props.clearAddressPart(type, query);}if (!query) {type === 'house_number' && _this3.props.clearAddressPart(type);} else {_this3.clearErrors(function (error) {return !error.startsWith('HOUSE') && !error.startsWith('ADDRESS');});}};this.getAutocompleteRequestType = function (type) {if (type === 'country_name') return ['(regions)'];if (type === 'city_name') return ['(cities)'];return ['geocode'];};this.getAutocompleteQuery = function (query, type) {var typeMapping = { country_name: query, city_name: _this3.props.isForeign ? _this3.props.address.country_name + ' ' + query : '' + query, street_name: _this3.props.address.city_name + ' ' + query, house_number: _this3.props.address.city_name + ' ' + _this3.props.address.street_name + ' ' + query };return typeMapping[type];};this.getSuggestionsOnLocus = function (newValue) {var isForeign = _this3.props.isForeign;if (isForeign) {var queryString = _this3.getAutocompleteQuery(newValue.query, newValue.type);var isoCode = _this3.getCountryCode(_this3.props.address.country_name);var locusSearchConfig = { country: isoCode, overseasOnly: true, locale: _this3.props.locale };var queryTypes = _this3.getAutocompleteRequestType(newValue.type);return _this3.props.googleService.autocompleteLocusViaGoogle(queryString, queryTypes[0], locusSearchConfig);}var _get = (0, _get3.default)(_this3.props, 'fullAddressModel.tags', []),cityName = _get[0];var parentTags = cityName ? [cityName] : undefined;var type = parentTags ? 'street' : 'city';return _this3.props.googleService.autocompleteLocusViaInternalBase(newValue.query, parentTags, type, { locale: _this3.props.locale });};this.getAutocompleteSuggestions = function (newValue) {if (!_this3.props.googleService) {return null;}_this3.setState({ errors: [] });return _this3.getSuggestionsOnLocus(newValue).then(function (suggestions) {if (!suggestions.length) {return _this3.tryAutocompleteGoogle(newValue);}_this3.setState({ suggestions: suggestions });return suggestions;}).catch(function () {return _this3.tryAutocompleteGoogle(newValue);});};this.getErrorTooltip = function (_ref) {var firstError = _ref[0],rest = _ref.slice(1);var errorMap = { HOUSE_NOT_EXISTS: _this3.props.translate('canNotFindAddress'), HOUSE_IS_REQUIRED: _this3.props.translate('enterHouseNumber'), ADDRESS_IS_INCOMPLETE: _this3.props.translate('fullAddressMessage'), ADDRESS_IS_CITY: _this3.props.translate('cityMessage'), ADDRESS_WAS_NOT_CREATED: _this3.props.translate('addressWasNotCreated'), MESSAGE_ERROR_ADDRESS: _this3.props.rootTranslate('messageErrorAddress') };return errorMap[firstError] || '';};this.getCountryCode = function (country) {if (!country) {return null;}var currentCountry = void 0;currentCountry = _countriesMin2.default.find(function (el) {return el.address.en === country;});if (!currentCountry) {currentCountry = _countriesMin2.default.find(function (el) {return el.address.he === country;});}return currentCountry ? currentCountry.isoCode : '';};this.handleFocus = function (type) {_this3.props.setManualButtonState(false);_this3.setState({ fieldInFocus: type });_this3.country = _this3.country || document.getElementsByName(_this3.props.name + '.country_name')[0];_this3.city = _this3.city || document.getElementsByName(_this3.props.name + '.city_name')[0];_this3.street = _this3.street || document.getElementsByName(_this3.props.name + '.street_name')[0];_this3.clearErrors(function (error) {return !error.startsWith('HOUSE') && !error.startsWith('ADDRESS');});var targetName = document.activeElement.name;if (_this3.country && targetName === _this3.country.name) {// nothing to do here
    } else if (!_this3.props.address.country_name && _this3.country) {if (!_this3.state.loading || targetName !== _this3.city.name) {_this3.country.focus();}} else if (targetName === _this3.city.name && _this3.props.address.country_name && !_this3.state.loading) {// nothing to do here
    } else if (!_this3.props.address.city_name) {if (!_this3.state.loading || targetName !== _this3.street.name) {_this3.city.focus();}} else if (_this3.props.address.city_name && !_this3.props.address.street_name && !_this3.state.loading) {_this3.street.focus();}};this.isInvalidField = function (type) {var _props = _this3.props,isForeign = _props.isForeign,address = _props.address;var errors = _this3.state.errors;var hasError = errors.some(function (error) {return _constants.publishFormLocationErrors.has(error);});if (isForeign) {return type !== 'street_name' && type !== 'house_number' && !address[type] && hasError;}return !address[type] && hasError;};this.handleBlur = function (query) {var newState = {};if (query && _this3.state.suggestions.length) {newState.loading = true;_this3.searchSelectedOption(_this3.state.suggestions[0]);}newState.suggestion = [];_this3.setState(Object.assign({}, newState));if (_this3.props.isForeign) {if (!(0, _get3.default)(_this3.props, 'address.city_name')) {_this3.setError(_constants.publishFormErrorNames.addressIsCity);}} else if (!query || !_this3.props.isFullAddress) {_this3.setError(_constants.publishFormErrorNames.addressIsIncomplete);}};this.trackSearch = function (value) {(0, _analyticsManager.trackPage)('/search?cat=publish&q=' + value);};this.validateAddress = function (address, method) {if (address && !address.isFull && method !== 'click') {(0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.error, _analyticsConstants.eventAction.search, _analyticsConstants.eventLabel.notValidAddress);}};this.tryAutocompleteGoogle = function (newValue) {var queryString = _this3.getAutocompleteQuery(newValue.query, newValue.type);var queryType = _this3.getAutocompleteRequestType(newValue.type);var isoCode = _this3.getCountryCode((0, _get3.default)(_this3.props, 'address.country_name', 'Israel'));var promise = _this3.props.googleService.autocompleteGoogle(queryString, queryType, { componentRestrictions: { country: isoCode } });if (promise instanceof Promise) {return promise.then(function (suggestions) {suggestions = suggestions.map(function (item) {return Object.assign({}, item, { suggestionType: newValue.type });});_this3.trackSearch(newValue);_this3.setState({ suggestions: suggestions });return suggestions;}).catch(function (err) {_this3.props.googleService.handleError(err);_this3.setError(_constants.publishFormErrorNames.messageErrorAddress);});}return Promise.resolve();};this.tryToFindFullAddress = function (house_number) {_this3.props.setPreloaderState(true);var tags = (0, _get3.default)(_this3.props, 'fullAddressModel.tags');var getSuggestions = tags && !_this3.props.isForeign ? _this3.geocodeRequest({ tags: [].concat(tags.slice(0, 2), [house_number]), inputValue: house_number }) : _this3.getAutocompleteSuggestions({ query: house_number + ' ', type: 'house_number' }).then(function () {var suggestions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return suggestions && suggestions.length ? _this3.searchSelectedOption(Object.assign({}, suggestions[0], { inputValue: house_number })) : Promise.resolve();}).then(function (address) {if (!address) {// this.props.clearAddressPart('house_number');
        _this3.props.changeValue(_this3.props.name, Object.assign({}, _this3.props.fullAddressModel, { isFull: false, en: Object.assign({}, _this3.props.fullAddressModel.en, { house_number: house_number }), he: Object.assign({}, _this3.props.fullAddressModel.he, { house_number: house_number }) }));}return Promise.resolve(address);});getSuggestions.then(function (data) {if (data && data.isFull) {_this3.props.getInputData(data);} else if (!_this3.props.isForeign || !((0, _get3.default)(data, 'en.country_name', false) || !(0, _get3.default)(data, 'en.city_name', false))) {_this3.props.setManualButtonState(true);_this3.setError(_constants.publishFormErrorNames.houseDoesntExist);}}).then(function () {return _this3.props.setPreloaderState(false);});};this.searchFullAddressInLocus = function (address, house) {var addressData = address || _this3.props.fullAddressModel;var tags = addressData.tags ? [].concat(addressData.tags.slice(0, 2), [house]) : [(0, _slugify2.default)((0, _get3.default)(addressData, 'en.city_name', '')), (0, _slugify2.default)((0, _get3.default)(addressData, 'en.street_name', '')), house];return _this3.props.googleService.performGeocodeLocusByInnerBase(tags);};this.checkEnStreet = function (enStreetName, data) {return _TranslationService2.default.suggestStringLanguage(enStreetName).then(function (res) {return res.language === 'he' && res.probability > 0.5 ? _this3.findAndGeocodeInLocus(enStreetName) : Promise.resolve(data);});};this.findAndGeocodeInLocus = function (streetName) {return _this3.getSuggestionsOnLocus(streetName).then(function (data) {if (data && data[0]) {return _this3.props.googleService.performGeocodeLocusByInnerBase(data[0].tags);}return Promise.reject(new Error('Not found'));});};this.geocodeRequest = function (selectedSuggestion, method) {var address = selectedSuggestion.description || '';address = address.replace(/"/g, '״');var geocode = selectedSuggestion.tags && !_this3.props.isForeign ? _this3.props.googleService.performGeocodeLocusByInnerBase(selectedSuggestion.tags) : _this3.props.googleService.geocodeLocusViaGoogle(selectedSuggestion.place_id, _this3.props.address.country_name);if (_this3.props.isForeign) {geocode.then(function (data) {var enCityName = (0, _get3.default)(data, 'en.city_name');return enCityName && !selectedSuggestion.tags ? _this3.checkEnStreet(enCityName, data) : data;});}geocode.then(function (data) {var enStreetName = (0, _get3.default)(data, 'en.street_name');return enStreetName && !selectedSuggestion.tags ? _this3.checkEnStreet(enStreetName, data) : data;}).then(function () {var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var response = selectedSuggestion.suggestionType === 'street_name' && resp.isFull ? Object.assign({}, resp, { isFull: false, en: Object.assign({}, resp.en, { house_number: null }), he: Object.assign({}, resp.he, { house_number: null }) }) : resp;if (!response) {response = Object.assign({}, _this3.props.fullAddressModel, { isFull: false, en: Object.assign({}, _this3.props.fullAddressModel.en, { house_number: selectedSuggestion.inputValue }), he: Object.assign({}, _this3.props.fullAddressModel.he, { house_number: selectedSuggestion.inputValue }) });}_this3.validateAddress(response, method);_this3.props.getInputData(response);_this3.props.setHomeNumberManually(selectedSuggestion.inputValue);_this3.setState({ loading: false });return response;}).catch(function (err) {_this3.props.googleService.handleError(err);_this3.setState({ loading: false });return err;});return geocode;};this.searchSelectedOption = function (selectedSuggestion, method) {_this3.setState({ suggestions: [] });return _this3.geocodeRequest(selectedSuggestion, method);};this.createInputParameters = function (name) {return { name: _this3.props.name + '.' + name, suggestions: _this3.state.suggestions, initialValue: _this3.props.address[name] || _this3.props[name] || '', searchSelectedOption: _this3.searchSelectedOption, className: (0, _classnames2.default)(styles[name]), locale: _this3.props.locale, receiveSuggestions: _this3.debouncedGetAutocompleteSuggestions, placeholder: _this3.props.translate(placeholderMap[name]).toString(), fieldValue: _this3.props.address ? _this3.props.address[name] : {}, onQueryStringChange: _this3.onQueryStringChange, handleFocus: _this3.handleFocus, inFocus: _this3.state.fieldInFocus === name, handleBlur: _this3.handleBlur, params: { type: name } };};this.handleChangeCountry = function (value) {if (!value) {_this3.props.clearAddressPart('country_name', value);return;}var currentCountry = _countriesMin2.default.find(function (el) {return el.id === value.id;});_this3.setState({ isoCode: currentCountry.isoCode });var data = Object.assign({}, _this3.props.fullAddressModel, { isFull: false, google_place_id: '', location: { lat: currentCountry.location[0], lon: currentCountry.location[1] }, map: currentCountry.bounds, en: { country_name: currentCountry.address.en }, he: { country_name: currentCountry.address.he } });_this3.props.getInputData(data);_this3.city.focus();};this.renderInfoTooltipButton = function () {return _this3.props.withTooltipImage && _react2.default.createElement('img', { className: styles.infoTooltipButton, src: !!_this3.state.errors.length ? '/icons/exclamation-button.png' : '/icons/exclamation-mark.png', alt: 'warning-icon', tabIndex: 0, onBlur: function onBlur() {return _this3.setState({ showTooltip: false });}, onClick: function onClick() {return _this3.setState({ showTooltip: !_this3.state.showTooltip });} });};};PublishFormLocationInput.propTypes = {
  placeholder: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  token: _propTypes2.default.string,
  getInputData: _propTypes2.default.func,
  googleService: _propTypes2.default.object,
  autocompleteGoogle: _propTypes2.default.func,
  initialValue: _propTypes2.default.object,
  isInvalid: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  manualAddress: _propTypes2.default.bool,
  isFullAddress: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  getComponentInstance: _propTypes2.default.func,
  setHomeNumberManually: _propTypes2.default.func,
  setPreloaderState: _propTypes2.default.func,
  setManualButtonState: _propTypes2.default.func,
  clearAddressPart: _propTypes2.default.func,
  address: _propTypes2.default.object,
  fullAddressModel: _propTypes2.default.object,
  isDefaultLanguage: _propTypes2.default.bool,
  withTooltipImage: _propTypes2.default.bool,
  isRealtor: _propTypes2.default.bool,
  city_name: _propTypes2.default.string,
  street_name: _propTypes2.default.string,
  country_name: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  rootTranslate: _propTypes2.default.func };exports.default =


PublishFormLocationInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationInput/PublishFormLocationInput/PublishFormLocationInput.js
// module id = 2704
// module chunks = 0